import i18n from "@/plugins/i18n";
import store from '../store';

const root = "response_messages.";

function parseMessage(errorName) {
    const complete_name = root.concat(errorName);
    const message = i18n.t(complete_name);

    if (message == "response_messages.undefined") {
        return i18n.t("response_messages.misc.unexpected_error")
    } else {
        return message;
    }
}

function notify(type, message, basic = false) {
    if (!basic) {
        const parsedMessage = this.$parseResMessage(message);

        this.$toast.open(
            {
                message: parsedMessage,
                dissmissable: true,
                duration: 5000,
                type: type
            }
        )
    } else {
        this.$toast.open(
            {
                message: message,
                dissmissable: true,
                duration: 5000,
                type: type
            }
        )
    }
}

function formatDate(value) {
    if (!value) return "-";
    let current_datetime = new Date(value);
    return (
        current_datetime.getDate() +
        "/" +
        (current_datetime.getMonth() + 1) +
        "/" +
        current_datetime.getFullYear() +
        " - " +
        current_datetime.getHours() +
        ":" +
        (current_datetime.getMinutes() < 10 ? "0" : "") +
        current_datetime.getMinutes()
    );
}

function normalizeString (str) {
    return str.toLowerCase()
        .normalize("NFKD")
        .replace(/\u0307/g, "");
}

//#region array sorters

function sortAlphabetically(input, base, ascending) {
    const deepCopy = input.slice()

    if (ascending) {
        deepCopy.sort( (a, b) => {
            const itemA = a[base].toLowerCase();
            const itemB = b[base].toLowerCase();

            if (itemA < itemB)
            {
                return -1;
            }
            if (itemA > itemB)
            {
                return 1;
            }
            return 0;
        });
    } else {
        deepCopy.sort( (b, a) => {
            const itemA = a[base].toLowerCase();
            const itemB = b[base].toLowerCase();

            if (itemA < itemB)
            {
                return -1;
            }
            if (itemA > itemB)
            {
                return 1;
            }
            return 0;
        });
    }

    return deepCopy;
}

function sortNumerically(input, base, ascending) {
    const deepCopy = input.slice();
    if (ascending) {
        deepCopy.sort( (a, b) => a[base] - b[base]);
    } else {
        deepCopy.sort( (b, a) => a[base] - b[base]);
    }

    return deepCopy;
}

function sortDates(input, base, ascending) {
    const deepCopy = input.slice();
    if (ascending) {
        deepCopy.sort((a, b) => {
            const dateA = new Date(parseDate(a[base]).year, parseDate(a[base]).month, parseDate(a[base]).day);
            const dateB = new Date(parseDate(b[base]).year, parseDate(b[base]).month, parseDate(b[base]).day); 
            return dateA - dateB;
        });
    } else {
        deepCopy.sort((b, a) => {
            const dateA = new Date(parseDate(a[base]).year, parseDate(a[base]).month, parseDate(a[base]).day);
            const dateB = new Date(parseDate(b[base]).year, parseDate(b[base]).month, parseDate(b[base]).day);
            return dateA - dateB;
        });
    }

    return deepCopy;
}

function parseDate(_date) {
    const date = _date.split('/');

    const year = date[0];
    const month = date[1];
    const day = date[2];

    return { year, month, day };
}

//#endregion array sorters

//#region job queues

function addQueuedJob(job) {
    const existing_jobs = store.state.app.queued_jobs;
    store.dispatch('app/setQueuedJobs', [...existing_jobs, job]);
}

//#endregion job queues

export {
    parseMessage,
    notify,
    formatDate,
    normalizeString,
    sortAlphabetically, 
    sortNumerically, 
    sortDates,
    addQueuedJob,
};